/**
 * BOM create／update 寫入 payload。
 * Wire：`groups[].mtrs`／`extraMtrs`（禁舊 `materials`／`extraMaterials`）。
 * 輸入：表單 `groups[].materials`／`extraMaterials`；冪等支援已 serialize 的 `mtrs`／`extraMtrs`。
 * 禁止：status、groups[].mtrs[].qty、讀取嵌套 mtr。
 */
import {
  sortBomMaterialsByCode,
  sortBomPositionsByName,
} from '#/modules/momMgmt/settings/bom/helper/bomSort';

function resolveGroupMaterials(group) {
  return group?.mtrs ?? group?.materials ?? [];
}

function resolveExtraMaterials(values) {
  return values?.extraMtrs ?? values?.extraMaterials ?? [];
}

export function buildBomWritePayload(values, { updatedAt = null } = {}) {
  const groups = (values?.groups ?? []).map((group) => ({
    name: group.name,
    mtrs: sortBomMaterialsByCode(resolveGroupMaterials(group)).map((material) => ({
      mtrId: material.mtrId,
      positions: sortBomPositionsByName(material.positions ?? []).map((position) => ({
        name: position.name,
        usageType: position.usageType,
      })),
    })),
  }));

  const extraMtrs = resolveExtraMaterials(values).map((item) => ({
    mtrId: item.mtrId,
    qty: Number(item.qty),
  }));

  const payload = {
    code: values?.code,
    name: values?.name,
    version: values?.version,
    remark: values?.remark ?? null,
    groups,
    extraMtrs,
  };

  if (updatedAt != null && updatedAt !== '') {
    payload.updatedAt = updatedAt;
  }

  return payload;
}
